export enum AccountType {
  Checking = 'checking',
  Liability = 'liability',
  Reserve = 'reserve',
}
